module.exports = __webpack_public_path__ + "img/no_picture_hotel.ca7fe5aa.jpg";